var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTak3Lengeh4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 30",
    style: {
      enableBackground: "new 0 0 60 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.1,15.2H28c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.1c0.3,0,0.5,0.2,0.5,0.5S34.3,15.2,34.1,15.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.4,17.4 28.4,12 25.6,14.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1,15.2h-6.7c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h6.7c0.3,0,0.5,0.2,0.5,0.5C53.6,15,53.4,15.2,53.1,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8,18.6c-0.3,0-0.5-0.2-0.5-0.5v-6.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v6.7C50.3,18.3,50,18.6,49.8,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2,15.2H6.5C6.2,15.2,6,15,6,14.7c0-0.3,0.2-0.5,0.5-0.5h6.7c0.3,0,0.5,0.2,0.5,0.5C13.7,15,13.5,15.2,13.2,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8,18.6c-0.3,0-0.5-0.2-0.5-0.5v-6.7c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v6.7C10.3,18.3,10.1,18.6,9.8,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,30H0V0h60V30z M1,29h58V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8,25.5H23.6V4.6h13.2V25.5z M24.6,24.6h11.3v-19H24.6V24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8,29.9c-0.2,0-0.4-0.2-0.4-0.4V0.8c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v28.7C20.2,29.7,20,29.9,19.8,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9,29.9c-0.2,0-0.4-0.2-0.4-0.4V0.8c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v28.7C40.3,29.7,40.2,29.9,39.9,29.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTak3Lengeh4);
export default __webpack_public_path__ + "static/media/tak_3_lengeh_4.46448dc8c39efac1d3fc77d5d222510c.svg";
export { ForwardRef as ReactComponent };